/**
 * Public verification URL encoded into the printed clinic QR door sign.
 *
 * Keyed by clinic id, not by request id: the clinic row outlives the
 * registration/onboarding request that created it, so a sign printed today keeps
 * resolving after that request is archived, and newly-registered and onboarded
 * existing clinics share one code path.
 *
 * The host defaults to the current origin so nothing is hardcoded per
 * environment. REACT_APP_PUBLIC_BASE_URL exists as an override for the case
 * where signs must be printed from an internal host but scanned against the
 * public one.
 */
export const PUBLIC_VERIFY_PATH = "/clinic/verify";

export function getPublicBaseUrl(): string {
  const configured = process.env.REACT_APP_PUBLIC_BASE_URL;
  const base = configured && configured.trim() ? configured.trim() : window.location.origin;
  return base.replace(/\/+$/, "");
}

export function buildClinicVerifyUrl(clinicId: string): string {
  return `${getPublicBaseUrl()}${PUBLIC_VERIFY_PATH}/${clinicId}`;
}
